import { render, staticRenderFns } from "./LargeSplashScreen.vue?vue&type=template&id=0945d1ba"
import script from "./LargeSplashScreen.vue?vue&type=script&lang=ts"
export * from "./LargeSplashScreen.vue?vue&type=script&lang=ts"
import style0 from "./LargeSplashScreen.vue?vue&type=style&index=0&id=0945d1ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports